var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgenew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 20,
    viewBox: "0 0 71 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 0L49 8L55 16H4V0H55Z",
    fill: "#76C065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.034 12V4.3H12.211L17.04 10.229H16.457V4.3H17.876V12H16.699L11.87 6.071H12.453V12H11.034ZM21.2593 7.501H25.0873V8.678H21.2593V7.501ZM21.3693 10.801H25.7143V12H19.9393V4.3H25.5603V5.499H21.3693V10.801ZM29.016 12L26.464 4.3H27.949L30.226 11.263H29.489L31.854 4.3H33.174L35.473 11.263H34.758L37.09 4.3H38.454L35.902 12H34.384L32.283 5.719H32.679L30.545 12H29.016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H4V16H0V2Z",
    fill: "#76C065"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.12852e-06 16L6 16L6 20L-1.12852e-06 16Z",
    fill: "#4C9F39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgenew);
export default __webpack_public_path__ + "static/media/badge new.46cbbbef7f75d1855b902c891ba9f2bd.svg";
export { ForwardRef as ReactComponent };